import { Link, useNavigate } from 'react-router-dom';
import { Layout } from '@/components/Layout';

export function LandingPage() {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="text-center py-16">
        <h1 className="text-5xl font-bold text-gray-900 mb-6">
          Living Statement of Work
        </h1>
        <p className="text-xl text-gray-600 mb-12 max-w-2xl mx-auto">
          Vistora keeps your Statement of Work accurate as scope changes during
          your project. Record changes, preserve history, and maintain a single
          source of truth.
        </p>
        <div className="flex gap-4 justify-center">
          <Link
            to="/create"
            className="bg-blue-600 text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-blue-700"
          >
            Create a SOW
          </Link>
          <button
            onClick={() => {
              const token = prompt('Enter your client access token:');
              if (token) navigate(`/client/${token}`);
            }}
            className="bg-gray-200 text-gray-900 px-8 py-3 rounded-lg text-lg font-semibold hover:bg-gray-300"
          >
            View Your SOW
          </button>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-8 mt-16">
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-xl font-bold text-gray-900 mb-3">
            Track Changes
          </h3>
          <p className="text-gray-600">
            Record all scope changes with timestamps and descriptions.
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-xl font-bold text-gray-900 mb-3">
            Full History
          </h3>
          <p className="text-gray-600">
            Preserve complete change history for full transparency.
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-xl font-bold text-gray-900 mb-3">
            Client Access
          </h3>
          <p className="text-gray-600">
            Share read-only access with clients via secure token.
          </p>
        </div>
      </div>
    </Layout>
  );
}
